import { useCallback } from 'react';
import { selectGenders, useAppInitStore } from '../../stores';

export const useGenders = () => {
	const genders = useAppInitStore(selectGenders);

	const getGenderById = useCallback((genderId: number) => genders.find((g) => g.id === genderId), [genders]);

	return { genders, getGenderById };
};
